/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["input", "label"];
import { render } from 'foundations-components/transitional/utils/customRenderer';
import { lazyEval } from 'foundations-components/transitional/utils/lazyEval';
import PropTypes from 'prop-types';
import { Component } from 'react';
export default class SingleNameInput extends Component {
  render() {
    const _this$props = this.props,
      {
        input,
        label
      } = _this$props,
      passThroughProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return render(input, Object.assign({
      label: lazyEval(label)
    }, passThroughProps, input.props), {
      mergeType: 'aggressive'
    });
  }
}
SingleNameInput.propTypes = {
  input: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node]).isRequired,
  label: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired
};